// extracted by mini-css-extract-plugin
module.exports = {"heroClassName":"About_heroClassName__0suZC","contentClassName":"About_contentClassName__W84lF","overlayShadow":"About_overlayShadow__xo3KR"};